import { types, flow } from "mobx-state-tree";

const Notification = types.model("Notification", {
  variant: types.optional(types.union(
    types.literal(""),
    types.literal("success"),
    types.literal("error"),
    types.literal("info"),
    types.literal("warning")
  ), ""),
  message: types.optional(types.string, ""),
});

const NotificationStore = types.model("NotificationStore", {
  notifications: types.array(Notification),
  transitioning: types.optional(types.boolean, false),
})
  .actions(self => ({
    enqueue: flow(function* enqueue({ variant, message }) {
      const notification = Notification.create({
        variant: variant,
        message: message,
      });
      self.notifications.push(notification);
      yield Promise.resolve();
    }),

    dequeue: flow(function* dequeue() {
      self.transitioning = true;
      yield new Promise(res => setTimeout(res, 100)).then(self._dequeue);
      self.transitioning = false;
      yield Promise.resolve();
    }),

    _dequeue: flow(function* _dequeue() {
      const length = self.notifications.length;
      self.notifications = self.notifications.slice(1, length);
      yield Promise.resolve();
    }),

    clear: flow(function* clear() {
      self.transitioning = true;
      yield new Promise(res => setTimeout(res, 100)).then(self._clear);
      self.transitioning = false;
      yield Promise.resolve();
    }),

    _clear: flow(function* _clear() {
      self.notifications.clear();
      yield Promise.resolve();
    }),

    error: flow(function* error(message) {
      yield self.enqueue({
        variant: "error",
        message: message,
      });
    }),

    success: flow(function* success(message) {
      yield self.enqueue({
        variant: "success",
        message: message,
      });
    }),

    info: flow(function* info(message) {
      yield self.enqueue({
        variant: "info",
        message: message,
      });
    }),

    warning: flow(function* warning(message) {
      yield self.enqueue({
        variant: "warning",
        message: message,
      });
    }),
  }))
  .views(self => ({
    current() {
      if (self.notifications.length > 0) {
        return self.notifications[0];
      }
      return Notification.create();
    },
  }));

export { Notification, NotificationStore };
